export class SalesOfficeFilter {
    
    public SalesOfficeTypeID?: number;
    public IncludeInactive?: boolean;
}

export default SalesOfficeFilter;